var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightMedium = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.146 8.145a.5.5 0 01.708 0l4.353 4.355-4.353 4.354a.5.5 0 11-.708-.707l3.646-3.647-3.646-3.648a.5.5 0 010-.707z"
  })));
});
export default SvgChevronRightMedium;